module.exports = __webpack_public_path__ + "static/media/QuestionMarkBookDark.a91d5fd0.svg";